import BaseRepository from '../../../../baseRepository/BaseRepository';
const resource = `/api/v1/traderequestchatswithadmin`;
export default { 
  getTradeRequestChatsWithAdmin(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params
    });
  },
  getTradeRequestChatsWithAdminById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  addTradeRequestChatsWithAdmin(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/bysupplier`, body, {
      baseURL,
      headers,
      params,
    });
  },
  editTradeRequestChatsWithAdmin(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${id}/bysupplier`, body, {
      baseURL,
      headers,
      params,
    });
  },
  deleteTradeRequestChatsWithAdminById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}/bysupplier`, {
      baseURL,
      headers,
      params,
    });
  },
};
